// extracted by mini-css-extract-plugin
export default {"heroContainer":"Hero_heroContainer__QRgfK","hero":"Hero_hero__UuQbw","gradient":"Hero_gradient__vDUeL"};